import { useState, useEffect } from "react"

import { useParams } from "react-router-dom"

import { useFirebase} from "@meddbriefer/mdb-firebase"

import { getPublishedScenarioObjectByID } from "@meddbriefer/scenario-data/index.js"

// import { SYSTEMS as SYS } from "@meddbriefer/scenario-data/constants.js"

import { ScenarioProvider } from "../contexts/ScenarioContext"

import ScenarioLayout from "../components/layouts/ScenarioLayout"

// const SYSTEM_IDS = [SYS.AW, SYS.BR, SYS.BL, SYS.SH]

const getDefaultValues = (scen) => {
    return {
        vitals: scen.initialVitalSigns,
        vitalsRecomputed: false,
        checkListItems: {},
        intvHistory: [],
        findingsUpdates: [],
    }
}

/*
 * returns an array of interventions associated with system, both filtered and ordered
 * by filteredIDs
 */
// const getSystemIntvIds = (scen, filteredIDs, system) => {
//     const systemIntvIDs = scen.systemInterventions[system].intvs.map(rec => rec.id)
//     return filteredIDs.filter(fID => systemIntvIDs.includes(fID))
// }

export default function Scenario({observer=null, next=null}) {
    const {db} = useFirebase()
    const { scenarioId } = useParams()
    const [scenario, setScenario] = useState(null)
    const [initValues, setInitValues] = useState(null)
    const [ready, setReady] = useState(false)

    useEffect(
        () => {
            const loadScen = () => {
                getPublishedScenarioObjectByID(db, scenarioId)
                .then(data => {
                    setScenario(data)
                    const defaults = getDefaultValues(data)
                    setInitValues(defaults)
                    setReady(true)
                })
                .catch(error => console.log(error))
            }
            loadScen()
        }, [db, scenarioId]
    )

    if (!ready) {
        return (<div>Loading scenario...</div>)
    } else {
        window.scenario = scenario
        return (
            <ScenarioProvider
                scenario={scenario}
                defaultValues={initValues}
            >
                <ScenarioLayout observer={observer} next={next}/>
            </ScenarioProvider>
        )
    }

}
